import type { Ref } from 'react';
import { RetryButton } from './retry-button';

const tradeListRetryClassName =
  'mt-3 rounded-md border border-danger-border-strong bg-card px-3 py-1 text-xs font-medium text-danger hover:bg-danger-soft-strong focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand-500';

/** Trade-list button classes plus min-h-6. Passed by the block-level error call sites. */
export const dataErrorRetryClassName =
  'mt-3 min-h-6 rounded-md border border-danger-border-strong bg-card px-3 py-1 text-xs font-medium text-danger hover:bg-danger-soft-strong focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand-500';

export function ErrorBox({
  title,
  retryLabel,
  retryingLabel,
  retrying = false,
  retry,
  headingAs = 'p',
  retryClassName = tradeListRetryClassName,
  retryRef,
  headingClassName = 'font-medium',
}: {
  title: string;
  retryLabel?: string;
  retryingLabel?: string;
  retrying?: boolean;
  retry?: () => void;
  headingAs?: 'p' | 'h1' | 'h2';
  retryClassName?: string;
  retryRef?: Ref<HTMLButtonElement>;
  /** Card detail passes the page-title size (CH-206 §1). */
  headingClassName?: string;
}) {
  const Heading = headingAs;
  const showRetry = retry != null && retryLabel != null && retryingLabel != null;
  return (
    <div
      role="alert"
      className="rounded-lg border border-danger-border bg-danger-soft p-6 text-sm text-danger"
    >
      <Heading className={headingClassName}>{title}</Heading>
      {showRetry ? (
        <RetryButton
          ref={retryRef}
          retrying={retrying}
          label={retryLabel}
          retryingLabel={retryingLabel}
          onRetry={retry}
          className={retryClassName}
        />
      ) : null}
    </div>
  );
}
